import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  removeButtons({ target }) {
    if (target.target === "admin_webcast_bids" && target.action === "prepend") {
      this.buttonTargets.forEach(button => {
        button.remove()
      })
    }
  }
}
